// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".date-range-trigger-input[data-v-618ef196],.date-range-trigger-input[data-v-618ef196] .v-input__slot,.date-range-trigger-input[data-v-618ef196] .v-text-field__slot,.date-range-trigger-input[data-v-618ef196] input,.date-range-trigger-input[data-v-618ef196] label{cursor:pointer}", ""]);
// Exports
module.exports = exports;
